







































/* General */

/* Mixins */
import EntityTypeMixin from '@/mixins/entity-type.mixin'

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { DefaultFilterIDs, EEntities } from '@/types'
import { IProjectsOutputProjectForHome } from '@/api/types/response.types'

/* API */

export default EntityTypeMixin.extend({
  name: 'DashboardTableView',

  props: {
    entities: {
      type: Array as () => Array<IProjectsOutputProjectForHome>,
      required: true,
    },
  },

  computed: {
    isMailbox(): boolean {
      return this.entityType === EEntities.MAILBOXES
    },
  },

  methods: {
    handleFavorite(entity: any) {
      this.$emit('favorite', entity, entity.isFavorite)
    },
    goToHome(entity: any) {
      switch (this.entityType) {
        case EEntities.MAILBOXES:
          return RouteAssistant.goToMailbox(
            this.$router,
            this.$route.params.accountId,
            entity.id,
            entity.name,
          )
        case EEntities.PROJECTS:
          return RouteAssistant.goToProjectLanding(
            this.$router,
            this.$route.params.accountId,
            entity.id,
            this.$permissions,
            entity.name,
          )
      }
    },
    getActiveRoute(entity: any) {
      switch (this.entityType) {
        case EEntities.MAILBOXES:
          return RouteAssistant.getMailboxRoute(
            this.$route.params.accountId,
            entity.id,
            entity.name,
            DefaultFilterIDs.ACTIVE,
          )
        case EEntities.PROJECTS:
          return RouteAssistant.getProjectLandingRoute(
            this.$route.params.accountId,
            entity.id,
            this.$permissions,
            entity.name,
            DefaultFilterIDs.ACTIVE,
          )
      }
    },
    getAssignedToYouRoute(entity: any) {
      switch (this.entityType) {
        case EEntities.MAILBOXES:
          return RouteAssistant.getMailboxRoute(
            this.$route.params.accountId,
            entity.id,
            entity.name,
            DefaultFilterIDs.ASSIGNED_TO_YOU,
          )
        case EEntities.PROJECTS:
          return RouteAssistant.getProjectLandingRoute(
            this.$route.params.accountId,
            entity.id,
            this.$permissions,
            entity.name,
            DefaultFilterIDs.ASSIGNED_TO_YOU,
          )
      }
    },
  },
})
